import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from "vue"
import { Theme } from "@/types"
import { THEMES } from "@/constants"
import PasswordInput from "@/components/widgets/input/PasswordInput.vue"
import Checkbox from "@/components/widgets/input/Checkbox.vue"
import { useNotification } from "@/hooks/useNotification"
import FormContainer from "../shared/FormContainer.vue"
import { useOnboardingContext } from "../shared/useOnboardingContext"

export type ClientPersonalInfoForm = {
  firstName: string
  lastName: string
  clientAdminPosition: string
  password: string
  email: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientPersonalInfoForm',
  props: {
  isSubmitting: {
    type: Boolean,
    default: false,
  },
  theme: {
    type: Object as PropType<Theme>,
    default: () => ({
      primaryColor: THEMES.PERALTA_PRIMARY,
      iconColor: THEMES.PERALTA_PRIMARY_RED,
    }),
    required: false,
  },
  submitBtnLabel: {
    type: String,
    default: "Continue",
  },
},
  emits: ["gotoNext", "change", "gotoPrev"],
  setup(__props, { emit }) {




const observer = ref(null)

const form = ref<ClientPersonalInfoForm>({
  firstName: "",
  lastName: "",
  clientAdminPosition: "",
  password: "",
  email: "",
})

const acceptedTermsAndPolicies = ref(false)

const { addError } = useNotification()

const { updateOnboardingForm } = useOnboardingContext()

const onSubmit = async () => {
  if (!acceptedTermsAndPolicies.value) return addError("Please accept the terms and policies")

  const validity = await (observer.value as any)?.validateWithInfo()
  if (!validity.isValid) return

  updateOnboardingForm({
    newUserInput: form.value,
  })

  emit("gotoNext")
}

return { __sfc: true,emit, observer, form, acceptedTermsAndPolicies, addError, updateOnboardingForm, onSubmit, PasswordInput, Checkbox, FormContainer }
}

})